import React from "react";
import PropTypes from "prop-types";
import * as R from "ramda";

import { Select } from "antd";

/**
 * Re-useable generation of Options for
 * select assuming that the give schema contains
 * key `options` with array
 * [
 *      {value: {mixed}, label: {String}},
 * ]
 */
class SchemaSelect extends React.Component {
    render() {
        const { disabled, schema } = this.props;
        const typeOptions = R.pathOr([], ["options"], schema).filter(
            d => !d.hideOnFrontend || d.value === this.props.value
        );
        const Option = Select.Option;
        return (
            <Select
                disabled={disabled}
                optionFilterProp="value"
                filterOption={(input, option) =>
                    option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }
                {...this.props}
            >
                {typeOptions.map(type => (
                    <Option
                        key={type.value}
                        value={type.value}
                        disabled={type.hideOnFrontend}
                    >
                        {type.label}
                    </Option>
                ))}
            </Select>
        );
    }
}

SchemaSelect.propTypes = {
    schema: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
};

export default SchemaSelect;
